import { useCallback, useEffect, useState } from 'react';

import ReactDOM from 'react-dom';

import { getSignedURL } from 'api/endpoints/upload';
import { handleImageSurvey } from 'utils/helper';

const ArrowCircleDark = require('assets/resources/ArrowCircleDark.svg').default;
const CloseCircleDark = require('assets/resources/CloseCircleDark.svg').default;

const Image = ({ item }) => {
  const [src, setSrc] = useState('');

  const handleLoadImage = useCallback(async () => {
    const signedURL = await getSignedURL({ blob_name: item.source_blob, bucket_name: item.source_bucket });
    const { signed_url, etag } = signedURL.data;
    const images = await handleImageSurvey([{ signed_url, etag }]);
    if (images.length > 0) {
      images[0]?.url_preview && setSrc(images[0].url_preview);
    }
  }, [item.source_blob, item.source_bucket]);

  useEffect(() => {
    handleLoadImage();
  }, [handleLoadImage]);

  return src && <img src={src} alt="image" className="max-h-216.75" />;
};

const ImagePreview = (props) => {
  const { data, close, firstOpen } = props;
  const [currentIndex, setCurrentIndex] = useState(firstOpen);

  useEffect(() => {
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('h-screen');

    return () => {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('h-screen');
    };
  }, []);

  const onPrev = () => {
    if (currentIndex === 0) {
      setCurrentIndex(data.length - 1);
    } else {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const onNext = () => {
    if (currentIndex === data.length - 1) {
      setCurrentIndex(0);
    } else {
      setCurrentIndex(currentIndex + 1);
    }
  };

  return ReactDOM.createPortal(
    <div data-testid="modal" id="modal" className="fixed inset-0 flex-middle-center bg-black bg-opacity-50 z-max">
      <div className="relative w-full h-full flex justify-center items-center">
        <div className="absolute top-8 right-10 w-16 h-16 cursor-pointer" onClick={close}>
          <img src={CloseCircleDark} alt="image" width={64} height={64} />
        </div>
        <div className="flex justify-center items-center space-x-10">
          {data.length > 1 && <img src={ArrowCircleDark} alt="image" width={64} height={64} className="cursor-pointer" onClick={onPrev} />}
          <div className="w-150 h-216.75 flex overflow-hidden">
            {data.map((item, index) => (
              <div
                key={index}
                className="min-w-150 w-150 h-216.75 flex justify-center items-center transition-transform duration-300 ease-in-out"
                style={{ transform: `translateX(-${currentIndex * 600}px)` }}
              >
                <Image item={item} />
              </div>
            ))}
          </div>
          {data.length > 1 && <img src={ArrowCircleDark} className="rotate-180 cursor-pointer" alt="image" width={64} height={64} onClick={onNext} />}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ImagePreview;
